import React from "react";
import MapChartES from "../MapGraph/indexES";
import MapChartPT from "../MapGraph/index";

function getCountryFromHost() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host.includes("pt") || (host.includes("localhost"))) return "PT";
  }
  return "ES";
}


interface MapChartProps {
    setTooltipContent: any;
    values: number[];
    className?: string;
    loading?: boolean;
}

export default function MapChartSwitcher(props: MapChartProps) {
    const country = getCountryFromHost();
    if (country === "PT") return <MapChartPT {...props} />;
    return <MapChartES {...props} />;
}